import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import tw from 'tailwind-styled-components'
import { usePopupCadastralPlotQuery } from '@foros-fe/graphql'
import { Button } from '../../../components/Button'
import { LayerPopup, Props as LayerPopupProps } from './LayerPopup'
import { formatMoney } from '../../../utils'
import { getCadastralPlotCenter, googleDirectionsURL } from '../../../utils/cartography'

type Props = Pick<LayerPopupProps, 'position'> & {
  cadastralPlotId: string
  auctionId: string
}

const Line = tw.div`flex justify-between gap-4`
const Title = tw.div`text-xl font-medium my-2`

export const AuctionPopup: FC<Props> = ({ position, cadastralPlotId, auctionId }) => {
  const { t } = useTranslation(['forest', 'common', 'auctions'])
  const router = useRouter()
  const { data } = usePopupCadastralPlotQuery({ variables: { id: cadastralPlotId } })

  const popupCadastralPlot = data?.cadastralPlot
  const auction = popupCadastralPlot?.auctions?.find(({ id }) => id === auctionId)
  const center = getCadastralPlotCenter(popupCadastralPlot)

  return (
    <LayerPopup position={position} layer='cadastralPlots' title={t('common:map.cadastralPlot')}>
      <Title>{auction?.title}</Title>
      {popupCadastralPlot ? (
        <>
          <Line>
            <LayerPopup.Item
              label={t('common:startingPrice')}
              value={formatMoney(auction?.startingBid)}
            />
            {auction?.highestBidObject?.price ? (
              <LayerPopup.Item
                label={t('common:highestBid')}
                value={formatMoney(auction?.highestBidObject?.price)}
              />
            ) : null}
          </Line>
          {center ? (
            <div className='flex justify-start'>
              <a
                className='text-primary-500 text-base mb-2 hover:underline'
                href={googleDirectionsURL(center)}
                target='_blank'
                rel='noreferrer'
              >
                {t('common:navigateTo')}
              </a>
            </div>
          ) : null}
          <Button
            title={t('auctions:showMore')}
            value='cadastral-plot-popup-more'
            onClick={() => router.push(`/auctions/${auctionId}`)}
          />
        </>
      ) : null}
    </LayerPopup>
  )
}
